<div [ngClass]="containerClasses()">
  <div class="so-ai-loader__icon" [style.width]="iconSize()" [style.height]="iconSize()">
    <svg class="sparkle-animation" viewBox="0 0 24 24" [style.fill]="resolvedColor()">
      <!-- Small sparkle top-right -->
      <path class="sparkle sparkle-1" d="M19,1L17.74,3.75L15,5L17.74,6.26L19,9L20.25,6.26L23,5L20.25,3.75Z"/>
      <!-- Main sparkle center -->
      <path class="sparkle sparkle-2" d="M9,4L6.5,9.5L1,12L6.5,14.5L9,20L11.5,14.5L17,12L11.5,9.5Z"/>
      <!-- Small sparkle bottom-right -->
      <path class="sparkle sparkle-3" d="M19,15L17.74,17.74L15,19L17.74,20.25L19,23L20.25,20.25L23,19L20.25,17.74Z"/>
    </svg>
  </div>
  @if (showText() && text()) {
    <span class="so-ai-loader__text" [ngStyle]="textStyle()">{{ text() }}</span>
  }
</div>
